import React, { useEffect, useState } from "react";
import {
  useSearchParams,
  useParams,
  Link,
  useNavigate,
  createSearchParams,
} from "react-router-dom";
import { adminapiUrl, apiUrl } from "../Utils/constants";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  appAction,
  contactAction,
  emailAction,
} from "../Component/Redux/Feature/EmailSlice";
import {
  FormPageAction,
  sessionRed,
  sessionTrial,
  setStartDateParam,
  userDetailAction,
} from "../Component/Redux/Feature/UrlSlice";
import {
  SET_BRANCH,
  SET_CATEGORY,
  SET_TRIAL,
} from "../Component/Redux/Feature/CategorySlice";

const BranchSelect = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { categoryId, category } = useParams();
  const [branches, setBranches] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const [AllBranches, setAllBranches] = useState();

  const { selectedCategory } = useSelector((state) => state.Categories);

  const { userDetails } = useSelector((state) => state.UrlData);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  // "https://admin-node-staging.bodyprocoach.com/admin/read_allbranch_alltypes_allplans",

  const getBranches = async (passedCategory) => {
    try {
      setLoading(true);
      const res = await axios.get(
        adminapiUrl+"/read_allbranch_alltypes_allplans",
        // "https://admin-api.bodyprocoach.com/admin/read_allbranch_alltypes_allplans",
        {
          headers: {
            "Content-Type": "application/json",
          },
          mode: "no-cors",
        }
      );
      const data = res.data.data;

      dispatch(SET_CATEGORY(passedCategory));

      setAllBranches(data.All_branch);

      const branches = [];

      const branchsWithPlans = {};

      console.log("uid", passedCategory);

      console.log(
        "category check",
        data.All_categories.filter(
          (category) => category.slug == passedCategory
        )
      );

      const currentCategoryData = data.All_categories.filter(
        (category) => category.slug == passedCategory
      )[0].plans;

      data.All_categories.filter(
        (category) => category.slug == passedCategory
      )[0].plans.map((plan) => {
        if (!branches.includes(plan.branch_name))
          branches.push(plan.branch_name);
      });

      branches.map((branch) =>
        currentCategoryData.map((categoryPlan) => {
          if (categoryPlan.branch_name == branch) {
            console.log("branch name matched");
            if (branch in branchsWithPlans) {
              console.log("branchs with plans name matched");
              if (
                categoryPlan.slug != "" &&
                !branchsWithPlans[branch].plans.includes(categoryPlan.slug)
              ) {
                branchsWithPlans[branch].plans.push(categoryPlan.slug);
              }
            } else {
              if (categoryPlan.slug != "") {
                branchsWithPlans[branch] = {
                  plans: [categoryPlan.slug],
                };
              }
            }
          }
        })
      );

      console.log("branches with plans ==> ", branchsWithPlans);

      // setBranches(branches);

      setBranches(branchsWithPlans);

      console.log("branches  => ", branches);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      setError(true);
    }
  };

  const getOriginal = (str) => {
    return str
      .replace(/-/g, " ")
      .split(" ")
      .map((word) => {
        if (word === "on" || word === "Team") {
          return word.toLowerCase();
        } else {
          return word;
        }
      })
      .join(" ");
  };

  // function convertToOriginal(str) {
  //   // Split on dashes
  //   const words = str.split("-");

  //   // Lowercase specific words and handle potential leading/trailing spaces
  //   const originalWords = words.map((word) => {
  //     if (word === "on" || word === "Team") {
  //       return word.toLowerCase();
  //     } else {
  //       return word.trim(); // Remove leading/trailing spaces from individual words
  //     }
  //   });

  //   // Join words with spaces
  //   return originalWords.join(" ");
  // }

  useEffect(() => {
    if (category) {
      // console.log("formated category => ", convertToOriginal(category));
      // getBranches(getOriginal(category));
      if (searchParams.get("email"))
        dispatch(emailAction(searchParams.get("email")));

      if (searchParams.get("contact"))
        dispatch(contactAction(searchParams.get("contact")));

      if (searchParams.get("app"))
        dispatch(appAction(searchParams.get("app") === "true"));

      if (searchParams.get("trial"))
        dispatch(SET_TRIAL(searchParams.get("trial")));

      if (searchParams.get("email") && searchParams.get("contact"))
        dispatch(
          FormPageAction({
            email: searchParams.get("email"),
            phone: searchParams.get("contact"),
          })
        );

        

      if(searchParams.get("startdate")) {
        dispatch(setStartDateParam(searchParams.get("startdate")))
      }

      dispatch(
        userDetailAction({
          ...userDetails,
          startdate: searchParams.get("startdate"),
        })
      );

      console.log("selected category ", category);
      getBranches(category);

      dispatch(sessionRed([]));
      dispatch(sessionTrial([]));
    }
  }, [category]);

  return (
    <div className="home-page">
      <div className="categoryContainer">
        <div style={{ marginBottom: "1rem" }}>
          <img src="/pilatesLogo.png" width="250px"  style={{objectFit: "contain"}}></img>
        </div>
        <p>Please select branch</p>
       
        {!loading &&
          !error &&
          branches &&
          Object.keys(branches).length == 0 && (
            <p className="mt-1">No branches found</p>
          )}
        {!loading &&
          error &&
          !branches &&
          Object.keys(branches).length == 0 && (
            <p className="mt-1">Some error occurred</p>
          )}

        <div
          // style={{
          //   width: "100%",
          //   display: "flex",
          //   flexDirection: "column",
          //   gap: "1rem",
          //   marginTop: "1rem",
          // }}
          className="categoryListContainer"
        >
           {loading && !error && <div className="category mt-1">Loading...</div>}

          {branches &&
            Object.keys(branches).map((branch) => (
              <div
                onClick={() => {
                  dispatch(
                    SET_BRANCH(
                      AllBranches.filter(
                        (filterBranch) => filterBranch.branch_name == branch
                      )[0].slug
                    )
                  );
                  // navigate(
                  // `${
                  //   AllBranches.filter(
                  //     (filterBranch) => filterBranch.branch_name == branch
                  //   )[0].slug
                  // }/${branches[branch].plans[0]}`
                  // );
                  navigate({
                    pathname: `${
                      AllBranches.filter(
                        (filterBranch) => filterBranch.branch_name == branch
                      )[0].slug
                    }/${branches[branch].plans[0]}`,
                  });

                  // if (searchParams.get("trial")) {
                  //   navigate({
                  //     pathname: `${
                  //       AllBranches.filter(
                  //         (filterBranch) => filterBranch.branch_name == branch
                  //       )[0].slug
                  //     }/${branches[branch].plans[0]}`,

                  //     search: createSearchParams({
                  //       trial: searchParams.get("trial"),
                  //     }).toString(),
                  //   });
                  // } else
                  //   navigate({
                  //     pathname: `${
                  //       AllBranches.filter(
                  //         (filterBranch) => filterBranch.branch_name == branch
                  //       )[0].slug
                  //     }/${branches[branch].plans[0]}`,
                  //   });
                }}
                className="category"
              >
                {/* <Link
                to={`${branch.replace(/ /g, "-")}/${branches[branch].plans[0]}`}
              > */}

                <p>{branch}</p>

                {/* </Link> */}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default BranchSelect;
